import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { IImageSliderProps } from "./ImageSlider.interface";
import { TranslationContext } from "../../../shared/providers/translation/translation.provider";
import { ModuleContext } from "../../../shared/providers/module/module.provider";
import { CONTENT_BASE_URL } from "../../../shared/constants";
import { ComponentTypes } from "../../../shared/interfaces/modules.interface";
import { useIntersectionObserver } from "../../../shared/hooks/useIntersectionObserver";

function ImageSlider(props: IImageSliderProps) {
    const { lang } = useContext(TranslationContext);
    const slider = useRef<HTMLDivElement>(null);
    const [currentSlide, setCurrentSlide] = useState<number>(0);
    const { progress, setProgress } = useContext(ModuleContext);
    const [isCompleted, setIsCompleted] = useState<boolean>(false);

    const checkProgress = useCallback(
        (entry: any) => {
            if (!entry.isIntersecting) return;
            const element = entry.target as HTMLImageElement;
            setCurrentSlide(Number(element.dataset.index));
            
            const isItemId =
                props.id === progress?.itemId &&
                props.type === progress?.itemType;

            const isLastElement = element.parentElement?.lastChild === element;
            
            if (isLastElement && lang && !isItemId && !isCompleted) {
                setProgress({
                    unitId: props.unitId,
                    itemId: props.id,
                    progress: 100,
                    itemType: ComponentTypes.IMAGE_SLIDER,
                    itemLocale: lang
                });
                setIsCompleted(true);
            }
        },
        [progress, lang, props]
    );

    return (
        <section className="unit_item container-fluid gx-0">
            <div className="row gx-0">
                <div className="col-12">
                    <h2 className="text-h4-bd px-1 mb-1">{props.title}</h2>
                    <div className="slider_image is_full" ref={slider}>
                        <div className="slider_image-stage">
                            {props.images.map((img, i) => {
                                const { ref } = useIntersectionObserver(checkProgress);
                                return (
                                    <img
                                        ref={ref}
                                        key={i}
                                        src={`${CONTENT_BASE_URL}${img.url}`}
                                        alt={img.alt}
                                        data-index={i}></img>
                                );
                            })}
                        </div>
                        <div className="slider_image-navigation">
                            {props.images.map((_, i) => (
                                <span
                                    key={i}
                                    className={`navigation_item ${i === currentSlide ? "is_active" : ""}`}></span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ImageSlider;
